import {
  createApp
} from 'vue'
import App from './App.vue'
import Router from './router'

import 'jquery'
import 'jquery-ui'
import 'bootstrap/dist/css/bootstrap.min.css' //bootstrap 样式

import ElementPlus from "element-plus"
import 'element-plus/dist/index.css'
import 'bootstrap'
import 'bootstrap-icons/font/bootstrap-icons.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import {
  servicestatus,
  mapservtype
} from './js/querydata'
import i18n from './language/i18n'
import store from './store'
import mitt from 'mitt';


var uuid = mygetQueryString("uid");


const myapp = createApp(App)
//注册图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  myapp.component(key, component)
}
if (uuid != null) {
  myapp.config.globalProperties.uuid = uuid;
}

myapp.config.globalProperties.mapservtype = 'offline' //使用在线或本底缓存底图
myapp.config.globalProperties.loginstatus = 0; //0：表示没有登录
myapp.config.globalProperties.stopservice = false
myapp.config.globalProperties.$EventBus = new mitt() //注册一个全局事件传送
//myapp.use(store).use(Router).use(i18n).use(ElementPlus).mount('#app')


//网站停止服务
Router.beforeEach((to, from, next) => {
  if (myapp.config.globalProperties.stopservice == true) {
    if (to.fullPath === '/stopservice') next(true)
    else
      next('stopservice')
  } else
    next(true)
})

function mygetQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    var n1 = decodeURIComponent(r[2]);
    return n1;
  } else
    return '';
}

const checkservice = function () {
  servicestatus().then((res) => {
    if (res.status == '200') {
      if (res.data.status == 1)
        myapp.config.globalProperties.stopservice = false
      else {
        myapp.config.globalProperties.stopservice = true

        Router.push('stopservice')
      }
    } else //服务没反应也停止
    {
      myapp.config.globalProperties.stopservice = true

      Router.push('stopservice')
    }
  })
  return checkservice
}

const getmapservtype = function () {
  try {
    mapservtype().then((res) => {
        if (res.status == '200') {
          if (res.data.mapservtype == 'online')
            myapp.config.globalProperties.mapservtype = 'online'
          else {
            myapp.config.globalProperties.mapservtype = 'offline'
          }
        } else //服务没反应也停止
        {
          myapp.config.globalProperties.mapservtype = 'offline'
        }
        if(res.data.domestic=='1')
        {
           myapp.config.globalProperties.basemapfrom = 'tdt'//数据服务来源
        }
        else
        {
           myapp.config.globalProperties.basemapfrom = 'gaode'
        }
        myapp.use(store).use(Router).use(i18n).use(ElementPlus).mount('#app')
      })
    }
    catch (e) {
        console.log(e)
        myapp.use(store).use(Router).use(i18n).use(ElementPlus).mount('#app')
    }
    
}

getmapservtype() //检测底图服务类型
//30秒执行一次检查，查询网站是否可用
setInterval(checkservice(), 30000);